import React, { FC, Fragment } from 'react';
import { useFormikContext } from 'formik';
import { Grid } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';

import { ContentInput, UrlMetadataImage } from 'api';
import { getImageSrc } from 'helpers';
import { queryString } from 'utilities';

import { getPhoto } from 'features/content/helpers';
import { convertUrlImageToPhoto } from '../../helpers';

const { REACT_APP_IMGIX_HOST } = process.env;
const THUMBNAIL_SIZE = 72;

const useStyles = makeStyles({
  pointer: {
    cursor: 'pointer',
  },
});

interface IProps {
  images: UrlMetadataImage[];
}

const UrlPreview: FC<IProps> = ({ images }) => {
  const classes = useStyles();
  const theme = useTheme();
  const { values, setFieldValue } = useFormikContext<ContentInput>();

  function handleChangePhoto(image: UrlMetadataImage) {
    setFieldValue('content_object.photos', [convertUrlImageToPhoto(image)]);
  }

  function renderThumbnail(image: UrlMetadataImage, index: number) {
    const photo = getPhoto(values);
    const isSelected = photo?.key === image.file_key;
    const rawColor = theme.palette.primary.main.split('#')[1];

    const params = {
      h: THUMBNAIL_SIZE,
      w: THUMBNAIL_SIZE,
      fit: 'crop',
      auto: 'format',
      border: `3,${isSelected ? rawColor : 'FFFFFFFF'}`,
      'border-radius': 4,
    };

    const imageUrl = `${REACT_APP_IMGIX_HOST}/${image.file_key}?${queryString(params)}`;
    const imageSrc = getImageSrc(imageUrl);

    return (
      <Grid item key={index}>
        <img className={classes.pointer} onClick={() => handleChangePhoto(image)} {...imageSrc} />
      </Grid>
    );
  }

  if (!images) {
    return null;
  }

  return <Fragment>{images.map(renderThumbnail)}</Fragment>;
};

export default UrlPreview;
